import { useRef, useEffect, useState } from 'react';

function useElementVisible({
	onShow = () => {},
	onHide = () => {},
	options = {}
} = {}) {
	const elementRef = useRef();
	const [isVisible, setIsVisible] = useState(false);

	const observer = new IntersectionObserver(([entry]) => {
		if (entry.isIntersecting) {
			setIsVisible(true);
			onShow({ element: elementRef.current, isVisible });
		} else {
			setIsVisible(false);
			onHide({ element: elementRef.current, isVisible });
		}
	}, options);

	useEffect(() => {
		const element = elementRef.current;
		if (element) {
			observer.observe(element);
			return () => observer.disconnect(element);
		}
		//eslint-disable-next-line
	}, []);

	return {
		elementRef,
		isVisible
	};
}

export default useElementVisible;
